var _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllprojects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2C3.44772 2 3 2.44772 3 3V21C3 21.5523 3.44772 22 4 22H16C16.5523 22 17 21.5523 17 21V8L14 2H4Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2V8H20",
    fill: "#FFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 8,
    height: 2,
    fill: "#2196F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14,
    width: 8,
    height: 2,
    fill: "#2196F3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 18,
    width: 8,
    height: 2,
    fill: "#2196F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 22,
    width: 8,
    height: 2,
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllprojects);
export default __webpack_public_path__ + "static/media/allprojects.1ecfe61a5e15872ec14a11f2793685c0.svg";
export { ForwardRef as ReactComponent };